export const ConfigProps = {
    ActivateAdobeTargetDIVTagSafeZones: "Activate Adobe Target DIV Tag Safe Zones"
}